document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-prescription]').forEach(function (wrapper) {
    var toggleBtn = wrapper.querySelector('[data-prescription-toggle]');
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.toggle('is-open');
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('is-open');
      }
    });
  });
});